import { useContext } from 'react'
import { UserAchievementContext } from '../context/UserAchievementContext'

export function useUserAchievements() {
  return useContext(UserAchievementContext)
}
